module.exports = __webpack_public_path__ + "static/media/woocommerce.d8479f29.svg";